import http from '../../../../api/httpClient';

export const getRoles = async () => {
  try {
    const response = await http.get('/api/v1/cto/roles/');
    return response;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};

export const getRoleMenus = async (roleId: string) => {
  try {
    const response = await http.get(`/api/v1/cto/menu/all/${roleId}`);
    return response;
  } catch (error) {
    console.error('Error fetching role menus:', error);
    throw error;
  }
};

export const toggleRoleMenuAccess = async (roleId: string, menuId: string) => {
  try {
    const response = await http.patch(`/api/v1/cto/roles/${roleId}/menu/${menuId}`);
    return response;
  } catch (error) {
    console.error('Error toggling role menu access:', error);
    throw error;
  }
};

export const getRoleMenuActions = async (roleId: string, menuId: string) => {
  try {
    const response = await http.get(`/api/v1/cto/roles/${roleId}/menus/${menuId}/actions`);
    return response;
  } catch (error) {
    console.error('Error fetching role menu actions:', error);
    throw error;
  }
};

export const updateRoleMenuActions = async (roleId: string, menuId: string, actions: any[]) => {
  try {
    const response = await http.put(`/api/v1/cto/roles/${roleId}/menus/${menuId}/actions`, { actions });
    return response;
  } catch (error) {
    console.error('Error updating role menu actions:', error);
    throw error;
  }
};

export const createRole = async (roleData: any) => {
  try {
    const response = await http.post('/api/v1/cto/roles/', roleData);
    return response;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
};
